export default {
  methods: {
    track(event, cat, label) {
      this.$gtag.event(event, {
        event_category: cat,
        event_label: label,
      });
    },
    trackVal(event, cat, val) {
      this.$gtag.event(event, {
        event_category: cat,
        value: val,
      });
    },
  },
};
